<div *ngIf="!!attendee" [ngClass]="[attendee.Removed ? styles.removed : '', styles.row]">

	<vb-profile-picture [ngClass]="styles.imgComp" [altTxt]="'User_ProfilePicture' | translate : { '0': attendee.FullName }" [profileUrl]="attendee.ProfileImageUri">
	</vb-profile-picture>

	<div [ngClass]="styles.personalInfo">
		<span [ngClass]="styles.name" [hidden]="!attendee.Removed" title="{{ 'Event_AttendeeRemoved' | translate : { '0': attendee.FullName } }}">
			{{ 'Event_AttendeeRemoved' | translate : { '0': attendee.FullName } }}
		</span>

		<span [ngClass]="styles.name" [hidden]="attendee.Removed" [title]="attendee.FullName">{{ attendee.FullName }}
		</span>
		<span [ngClass]="styles.email" [title]="attendee.Email">
			{{ attendee.Email }}
		</span>
	</div>

	<button [hidden]="!allowRemove()" (click)="openRemoveAttendeeDialog()" class="btn btn-transparent" type="button" [attr.aria-label]="'Event_AttendeeRemove' | translate" [title]="'Event_AttendeeRemove' | translate">
		<span class="glyphicons remove_2"></span>
	</button>

	<button [hidden]="!allowRestore()" (click)="restoreAttendee(attendee)" type="button" [attr.aria-label]="'Event_AttendeeRestore' | translate" class="btn btn-transparent" [title]="'Event_AttendeeRestore' | translate">
		<span class="glyphicons undo"></span>
	</button>

	<vb-confirmation-dialog [title]="'Event_AttendeeRemove' | translate" [message]="'Event_RemoveWebcastAttendee' | translate : { '0': attendee.FullName }" [actionText]="'Remove' | translate" [cancelText]="'Cancel' | translate" [themed]="true">
	</vb-confirmation-dialog>
</div>
